import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';

export const fetchExecutions = createAsyncThunk('executions/fetchAll', async (scenarioId) => {
  const params = scenarioId ? { scenarioId } : {};
  const res = await api.get('/executions', { params });
  return res.data;
});

export const fetchExecution = createAsyncThunk('executions/fetchOne', async (id) => {
  const res = await api.get(`/executions/${id}`);
  return res.data;
});

const executionSlice = createSlice({
  name: 'executions',
  initialState: {
    list: [],
    selected: null,
    loading: false,
  },
  reducers: {
    clearSelected(state) {
      state.selected = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExecutions.pending, (state) => { state.loading = true; })
      .addCase(fetchExecutions.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchExecutions.rejected, (state) => { state.loading = false; })
      .addCase(fetchExecution.fulfilled, (state, action) => {
        state.selected = action.payload;
      });
  },
});

export const { clearSelected } = executionSlice.actions;
export default executionSlice.reducer;
